import { Box, styled, useTheme } from '@mui/material';
import { SocketsIcon } from '../../fields/icon/icons/socket';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
const hide = { display: 'none !important' };
const show = { display: 'block !important' };
export const SocketModel = styled(SocketsIcon, {
    shouldForwardProp: (prop) => prop !== ('online' || 'rotate_left'),
})(({ online, rotate_left }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode == 'dark';
    return {
        maxHeight: rotate_left ? 300 : 220,
        maxWidth: rotate_left ? 300 : 250,
        // height: '100%',
        opacity: online ? 1 : 0.7,
        // '& #plug': device_on ? show : hide,
        '& #plug': hide,
        transition: 'transform 0.2s',
        ...(rotate_left && {
            transform: 'rotate(90deg)',
        }),
        ...(isDark && {}),
    };
});
const card_width = 280;
const min_height = 100;
export const ModelView = styled(Box)({
    position: 'relative',
    fontSize: '2em',
    display: 'grid',
    width: '100%',
    gridTemplateColumns: `repeat(auto-fill, minmax(${isMediumUI() ? card_width * 1.3 : card_width}px, 1fr))`,
    gridTemplateRows: `repeat(auto-fill, minmax(${min_height}px, 1fr))`,
    gap: 8,
    transition: 'all 0.3s ease-in-out',
});
